// <head> metadata for SolutionsDataPipelinePlatformPage (https://www.dbos.dev/solutions/data-pipeline-platform).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Durable Data Pipeline Platform',
    },
    {
      name: 'description',
      content:
        'Breakthrough serverless platform makes data pipelines durable, scalable, and observable by default. Use it for Free.',
    },
    {
      property: 'og:title',
      content: 'Durable Data Pipeline Platform',
    },
    {
      property: 'og:description',
      content:
        'Breakthrough serverless platform makes data pipelines durable, scalable, and observable by default. Use it for Free.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/677b772d7002e0353e5307b2_DBOS-Durable-Data-Pipeline-Platform.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Durable Data Pipeline Platform',
    },
    {
      name: 'twitter:description',
      content:
        'Breakthrough serverless platform makes data pipelines durable, scalable, and observable by default. Use it for Free.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/677b772d7002e0353e5307b2_DBOS-Durable-Data-Pipeline-Platform.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/solutions/data-pipeline-platform',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
